export const GET_SERVICE_PACKAGES = 'GET_SERVICE_PACKAGES';
export const GET_SERVICE_PACKAGES_LOADING = 'GET_SERVICE_PACKAGES_LOADING';
export const CLEAR_SERVICE_PACKAGES = 'CLEAR_SERVICE_PACKAGES';

export const GET_MEMBERSHIP_PACKAGES = 'GET_MEMBERSHIP_PACKAGES';
export const GET_MEMBERSHIP_PACKAGES_LOADING = 'GET_MEMBERSHIP_PACKAGES_LOADING';
export const CLEAR_MEMBERSHIP_PACKAGES = 'CLEAR_MEMBERSHIP_PACKAGES';
